/**
 * home page video button shows ymm search
 * @todo don't hardcode paths, just search for hidden .easysearch-block-container with a-hrefs
 */
if (["/", "/pages/gift-giving-guide", "/collections/tmat-vehicle-kits", "/collections/tmat-suv-kits"].indexOf(window.location.pathname) !== -1) {
  document.addEventListener("DOMContentLoaded", function(arg) {

    document.querySelector(".easysearch-block-container").style.display = "none";

    var links = document.querySelectorAll('a.button[href="/collections/tmat-vehicle-kits"], a.button[href="/collections/tmat-suv-kits"]');
    if (links.length == 0) return;
    for (var i = 0; i < links.length; i++) {

      links[i].addEventListener("click", function(event) {
        event.preventDefault();
        this.style.display = "none";
        var targetElement = document.querySelector(".easysearch-block-container");
        targetElement.style.display = "block";
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      });
    }
  });
}


/*
 * Product page - YMM EasySearch - Redirect to correct product after fitment check on product page
 */
if (window.location.href.includes('/products/')) {
  document.addEventListener('easysearch_loaded', function (){
    let easyFitmentBtn = document.querySelector(".easysearch-fitment-widget .easysearch-btn-holder #easysearch-search");
    if (easyFitmentBtn){
      easyFitmentBtn.addEventListener("click", function(){ 
        let preselect = localStorage.getItem('easysearch-preselect') || '{"value":""}';
        let preselect_value = JSON.parse(preselect).value.replace(/easysearch-preselect-delimiter/gi, '|').replace(/\|$/, '');
        if (preselect_value) {
          klaviyo.push(["track", "Easysearch Selected",{
            "Value": preselect_value
          }]);
        }
        
        setTimeout(function() {
          let easyFitmentFail = document.querySelector(".easysearch-fitment-widget .easysearch-fitment-holder .easysearch-fitment-fail");
          let easyOtherResultsBtn = document.querySelector(".easysearch-fitment-widget .easysearch-fitment-other-results a");
          if(easyFitmentFail && easyOtherResultsBtn){
            easyOtherResultsBtn.click();
          }
        },1)
      });
    }
  }); 
}

/*
 * Product page - only show product accordions that are not empty (paired with style in tmat-custom.css)
 */
if (window.location.href.includes('/products/')) {
document.addEventListener('DOMContentLoaded', function() {
    // Target the accordions in the product info grid
    const accordions = document.querySelectorAll('.product-information__grid accordion-custom');

    accordions.forEach(acc => {
      const contentEl = acc.querySelector('.details-content');
      if (!contentEl) return; // skip if no content wrapper

      // Get raw text content, normalize whitespace
      let text = contentEl.textContent || '';
      text = text.trim().replace(/\s+/g, ' '); // collapse multiple spaces/newlines

      // Also check innerHTML to catch things like <br> or <p>&nbsp;</p> alone
      const html = contentEl.innerHTML.trim();

      // Consider it "empty" if:
      // - no meaningful text
      // - only whitespace / line breaks
      // - common empty patterns
      const isEmpty =
        text.length === 0 ||
        text === '' ||
        /^[\s\n\r\t&nbsp;]*$/.test(text) ||
        html === '' ||
        html === '<br>' ||
        html === '<p></p>' ||
        html === '<p>&nbsp;</p>' ||
        html === '<div></div>' ||
        /^<br\s*\/?>+$/i.test(html);

   
      if (!isEmpty) {
         acc.style.display = 'block'; // or 'block' if needed
      }
      else {
        acc.style.display = 'none';
        // Optional: acc.remove(); // if you prefer to fully remove from DOM (slightly more aggressive)
      }
    });
});
}




/**
 * Accordion - primarily used on the FAQ page
 * @seealso https://www.w3schools.com/howto/howto_js_accordion.asp
 */
document.addEventListener("DOMContentLoaded", function(arg) {
  var accordions = document.getElementsByClassName("tmat-accordion");

  for (var i = 0; i < accordions.length; i++) {
    accordions[i].nextElementSibling.style.display="none";
    
    accordions[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
});


/* Tmat Collection Swatch Swap — swaps image + link on swatch click — collection pages only /
(function(){var W=[240,352,832,1200,1600,1920,2560,3840];function S(u,w){return u.includes('width=')?u.replace(/width=\d+/,'width='+w):u+(u.includes('?')?'&':'?')+'width='+w}document.addEventListener('click',function(e){if(!window.location.pathname.includes('/collections'))return;var l=e.target.closest('.variant-option__swatch label');if(!l)return;var i=l.querySelector('input[data-connected-product-url]');if(!i)return;var url=i.getAttribute('data-connected-product-url'),vid=i.getAttribute('data-first-available-or-first-variant-id')||i.getAttribute('data-variant-id'),full=url+(vid?'?variant='+vid:''),sw=l.querySelector('span.swatch'),bg=sw&&getComputedStyle(sw).getPropertyValue('--swatch-background').trim(),m=bg&&bg.match(/url\(\s*['"]?(.*?)['"]?\s*\)/),src=m&&m[1];if(!src)return;var ps=l.closest('product-swatches');if(!ps)return;var pid=ps.getAttribute('data-product-id'),sel='div.card-gallery[data-product-id="'+pid+'"]',n=ps.parentElement,c;for(var x=0;x<6&&n;x++){if(n.querySelector(sel)){c=n;break}n=n.parentElement}if(!c)return;var g=c.querySelector(sel);if(!g)return;var a=g.querySelector('a[ref="cardGalleryLink"]');if(a)a.href=full;var img=g.querySelector('slideshow-slide img.product-media__image');if(img){img.srcset=W.map(function(w){return S(src,w)+' '+w+'w'}).join(', ');img.src=S(src,3840)}var sc=g.querySelector('slideshow-slides');if(sc)sc.scrollTo({left:0,behavior:'instant'});var cl=c.querySelector('a.product-card__link');if(cl)cl.href=full;i.checked=true},true)})();

/* Tmat PDP Fix — Force full reload on product-to-product navigation /
(function(){
  if(window.navigation){
    window.navigation.addEventListener('navigate',function(e){
      try{
        var from=window.location.pathname;
        var to=new URL(e.destination.url,window.location.origin).pathname;
        if(from.includes('/products/')&&to.includes('/products/')&&from!==to){
          e.preventDefault();
          window.location.assign(e.destination.url);
        }
      }catch(err){}
    });
  }
*/